import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const container = document.getElementById("root");
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
